/**
 * Clock synced with the server. Every API response has `serverNow`; the offset
 * fixes countdowns when the phone clock is wrong.
 */
let offsetMs = 0;

export function syncClock(serverNowIso: string): void {
  const server = new Date(serverNowIso).getTime();
  if (!Number.isNaN(server)) offsetMs = server - Date.now();
}

/** Current time (ms) corrected by the server clock. */
export function nowMs(): number {
  return Date.now() + offsetMs;
}
